module.exports = __webpack_public_path__ + "img/main_cn3.f9df8be2.svg";